import { TradingPair } from "shared/model";

// Группы идут в порядке: открытый рынок → закрытый рынок.
// Внутри каждой группы пары сортируются по payout (по убыванию).
const groupRank = (pair: TradingPair) => (pair.isMarketOpen ? 0 : 1);

export const sortPairs = (pairs: TradingPair[]): TradingPair[] =>
  [...pairs].sort(
    (a, b) =>
      groupRank(a) - groupRank(b) || b.winPayoutPercent - a.winPayoutPercent,
  );
